import React from 'react';
import './CompanyStorySection.css';

const CompanyStorySection: React.FC = () => {
  return (
    <section className="company-story-section">
      <div className="container">
        <div className="story-content">
          <div className="story-text">
            <div className="section-title">
              <h2>Our Story</h2>
              <p>From vision to reality: How Kavodax came to life</p>
            </div>
            <div className="story-details">
              <p>
                Founded in 2025, Kavodax emerged from a simple yet powerful observation: 
                traditional cross-border payment systems were failing millions of people 
                worldwide. High fees, slow processing times, and limited accessibility 
                were preventing individuals and businesses from participating in the 
                global economy.
              </p>
              <p>
                Our founder, with deep expertise in blockchain technology and financial 
                services, set out to create a solution that would democratize international 
                payments. By leveraging stablecoins and cutting-edge blockchain infrastructure, 
                we've built the first Canadian money movement platform specifically designed for 
                cross-border transactions.
              </p>
            </div>
          </div>
          <div className="story-timeline">
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h4>Company Founded</h4>
                <p>Kavodax was established with a mission to revolutionize cross-border payments</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h4>CodeLaunch Champion</h4>
                <p>Selected as the TOP startup across Canada at CodeLaunch Accelerator</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h4>Secured Funding</h4>
                <p>Received significant funding support to accelerate development and growth from OVH cloud as well as Spark Centre</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h4>Onboarded Blockchain Engineers</h4>
                <p>Expanded technical team with specialized blockchain development expertise</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;
